import React, { useEffect, useState } from 'react'
import Banner from './Banner';
import MobileInput from '../../components/InputGroup/MobileInput';
import InputText from '../../components/InputGroup/InputText';
import UserDetailForm from './UserDetailForm';
import BorkerDetails from './BorkerDetails';
import SiteVisitVerification from './SiteVisitVerification';
import CaptureImage from './CaptureImage';
import WelcomePage from './WelcomePage';
import CustomerInfo from './CustomerInfo';
import CustomerDetails from './CustomerDetails';
import BrokerVerification from './BrokerVerification';
import { toast } from 'react-toastify';
import { completeProjectVisit, getReVisitCustomerDetails, sendOTP, submitSiteVisitForm, verifyOTP } from '../../services/private/site-visit.service';
import BorkerDetailForm from './BrokerDetailForm';
import BrokerRegistration from './BrokerRegistrationModal';
import { useLocation } from 'react-router-dom';
import CPRegistration from './CPRegistration';
import AppQRCode from './AppQRCode';
import AreYouSureModal from '../../components/Modals/AreYouSureModal';
import CustomerRevisitModal from '../SItevisitFlow/Modal/CustomerRevisitModal';
import SiteVisitOTPModal from '../TabletForm/Modal/SiteVisitOTPModal';
import VerifyIdentityModal from '../TabletForm/Modal/VerifyIdentityModal';

const DivineReves = () => {
  const [channerPartner, setChannelPartner] = useState('1');
  const [isWithCP, setIsWithCP] = useState(false);
  const [detail, setDetail] = useState({
    name: '',
    email: '',
    address: '',
    company: '',
    profession: '',
    designation: '',
    panNo: '',
    aadhar: '',
    pincode: '',
    age: '',
  })
  const [name, setName] = useState('')
  const [mobile, setMobile] = useState('');
  const [altMobile, setAltMobile] = useState('');
  const [aboutProject, setAboutProject] = useState('');
  const [preference, setPrefrence] = useState('2 BHK');
  const [investement, setInvestment] = useState('90L-1CR');
  const [purpose, setPurpose] = useState('end use');
  const [possessionPreference, setPossessionPreference] = useState('Dec 2026')
  const [brokerCode, setBrokerCode] = useState('');
  const [image, setImage] = useState('');
  const [otp, setOTP] = useState('');
  const [otpVerifield, setOTPVerified] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [brokerName, setBrokerName] = useState();
  const [brokerMobile, setBrokerMobile] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [ownerMobile, setOwnerMobile] = useState('');
  const [ownerMail, setOwnerMail] = useState('');
  const [ownerName, setOwnerName] = useState('');
  const [others, setOthers] = useState('')
  const [referralName, setReferralName] = useState('')
  const [referralMobile, setReferralMobile] = useState('');
  const [society, setSociety] = useState('');
  const [flatNo, setFlatNo] = useState('');
  const [imgUrl, setImgUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [newBrokerName, setNewBrokerName] = useState('');
  const [newBrokerMobile, setNewBrokerMobile] = useState('');
  const [type, setType] = useState('')
  const [isCPVisit, setIsCPVisit] = useState(false);
  const [countDown, setCountDown] = useState(30);
  const [disableResend, setDisableResend] = useState(true);
  const [showMobileField, setShowMobileField] = useState(true);
  const [showCloseConfirmationModal, setShowCloseConfirmationModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [customerData, setCustomerData] = useState('');
  const [showCustomerRevisitModal, setShowCustomerRevisitModal] = useState(false);
  const [note, setNote] = useState('');
  const [isRevisit, setIsRevisit] = useState(false);
  const [showSiteVisitOTPModal, setShowSiteVisitOTPModal] = useState(false);
  const [showVerifyIdentityModal, setShowVerifyIdentityModal] = useState(true);
  const [city, setCity] = useState('');
  const [isWithoutMobile, setIsWithoutMobile] = useState(false);
  const [customerUuid, setCustomerUuid] = useState('');
  const [docName, setDocName] = useState('');
  const [docId, setDocId] = useState('');
  const [docUrl, setDocUrl] = useState('');

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);


  useEffect(() => {
    if (searchParams.get('type')) {
      setType(searchParams.get('type'))
    }
  }, [searchParams.get('type')]);

  useEffect(() => {
    let timer = setInterval(() => {
      if (countDown <= 0) {
        clearInterval(timer);
        setDisableResend(false);
      } else {
        setCountDown(countDown - 1)
      }
    }, 1000)

    return (() => clearInterval(timer))
  }, [countDown])

  useEffect(() => {
    if (name) {
      setDetail({ ...detail, name: name })
    }

  }, [name])

  const handleChangeDetail = (e) => {
    setDetail({ ...detail, [e.target.name]: e.target.value })
  }

  const handleSubmitData = async (otp) => {
    setIsSubmitting(true)
    const payload = {
      otp: otp,
      customer_name: detail.name || name || null,
      customer_mobile: mobile || null,
      project_id: 2367,
      broker_code: brokerCode || null,
      email: detail.email || null,
      address: detail.address || null,
      company: detail.company || null,
      profession: detail.profession || null,
      designation: detail.designation || null,
      pan_no: detail.panNo || null,
      aadhar: detail.aadhar || null,
      preference: preference || null,
      investement: investement || null,
      purpose: purpose || null,
      image: imgUrl || null,
      alt_mobile: altMobile || null,
      about_project: isWithCP ? 'CP' : aboutProject,
      broker_company_id: companyId?.value || null,
      broker_name: brokerName || newBrokerName || null,
      broker_mobile: brokerMobile || newBrokerMobile || null,
      broker_company_name: companyName || null,
      company_owner_name: ownerName || null,
      company_owner_mobile: ownerMobile || null,
      company_owner_email: ownerMail || null,
      possession_preference: possessionPreference || null,
      reference_name: referralName || null,
      reference_mobile: referralMobile || null,
      reference_flat_no: flatNo || null,
      reference_society: society || null,
      other_source: others || null,
      note: note || null,
      pincode: detail.pincode || null,
      age: detail.age || null,
      city: city || null,
      is_without_mobile: isWithoutMobile || null,
      customer_uuid: customerUuid || null,
      doc_name: docName || null,
      doc_id: docId || null,
      doc_url: docUrl || null,
    }
    try {
      const res = await submitSiteVisitForm(payload, { type });
      if (res.data.status === 200) {
        // toast.success(res.data.message);
        setOTPVerified(true)
      }
    } catch (err) {
      toast.error(err.response.data.message)
      console.log(err.response.data.message)
      if (err.response.data.message === 'Incorrect OTP') {
        setOtpError(true);
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleSubmitCPVisit = async (otp) => {
    setIsSubmitting(true)
    const payload = {
      otp: otp,
      visitor_name: newBrokerName,
      visitor_mobile: newBrokerMobile,
      project_id: 2367,
      firm_name: companyName,
      owner_name: ownerName,
      owner_mobile: companyId ? null : ownerMobile,
      broker_company_id: companyId,
      image_url: imgUrl, //new
      email: ownerMail, //new
    }
    try {
      const res = await completeProjectVisit(payload);
      if (res.data.status === 200) {
        setChannelPartner('10');
      }
    } catch (err) {
      toast.error(err.response.data.message)
      console.log(err.response.data.message)
      if (err.response.data.message === 'Incorrect OTP') {
        setOtpError(true);
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleSendOTP = async () => {
    setIsLoading(true)
    const payload = {
      mobile: mobile || newBrokerMobile,
      email: detail.email || ownerMail,
      customer_name: detail.name || name || newBrokerName
    }
    try {
      const res = await sendOTP(payload, { project: 'dr' });
      if (res.data.status === 200) {
        toast.success(res.data.message);
        setCountDown(30);
        setDisableResend(true);
        setChannelPartner('6')
        setIsLoading(false);
        setShowCustomerRevisitModal(false)
      }
    } catch (err) {
      toast.error(err.response.data.message)
      setShowCustomerRevisitModal(false)
      if (err.response.data.data.remaining) {
        setChannelPartner('6')
      }
      setIsLoading(false);
    }
  }

  const handleGetReVisitCustomerDetails = async (phone) => {
    const payload = {
      mobile: phone.substring(2),
      project_id: 2367,
    }
    try {
      const res = await getReVisitCustomerDetails(payload);
      if (res.data.status === 200) {
        const customerData = res.data.data[0];
        setCustomerData(customerData);
        setShowCustomerRevisitModal(true);
        if (res.data.data?.length === 0) {
          setChannelPartner('3')
        }
        // Update state variables from API response
        if (customerData) {
          setIsRevisit(true);
          // Update name
          if (customerData.name) {
            setDetail({ ...detail, name: customerData.name });
            setName(customerData.name);
          }

          // Update mobile (already set from phone input)
          // mobile is already set from the phone input parameter

          // Update preference (property configuration)
          if (customerData?.preferred_configurations && customerData.preferred_configurations.length > 0) {
            setPrefrence(customerData.preferred_configurations[0]);
          }

          // Update investment (budget range)
          if (customerData?.budget) {
            // const minBudget = (parseInt(customerData.min_budget) / 100000).toFixed(1) + 'L';
            // const maxBudget = (parseInt(customerData.max_budget) / 100000).toFixed(1) + 'L';
            setInvestment(`${customerData.budget}`);
          }

          // Update purpose
          if (customerData?.purpose) {
            setPurpose(customerData.purpose);
          }

          if (customerData?.address || customerData?.profession || customerData?.designation || customerData?.pan_no || customerData?.aadhar || customerData?.company || customerData?.customer_email) {
            setDetail({
              ...detail,
              email: customerData?.customer_email || null,
              address: customerData?.address,
              profession: customerData?.profession || null,
              designation: customerData?.designation || null,
              panNo: customerData?.pan_no || null,
              aadhar: customerData?.aadhar || null,
              company: customerData?.company
            });
          }
          if (customerData?.reference_name) {
            setReferralName(customerData?.reference_name);
          }
          if (customerData?.reference_mobile) {
            setReferralMobile(customerData?.reference_mobile);
          }
          if (customerData?.reference_flat_no) {
            setFlatNo(customerData?.reference_flat_no);
          }
          if (customerData?.reference_society) {
            setSociety(customerData?.reference_society);
          }
          // Update possession preference
          if (customerData?.possession) {
            setPossessionPreference(customerData?.possession);
          }
        }
      }
    } catch (err) {
      toast.error(err.response.data.message)
      console.log(err.response.data.message)
      setChannelPartner('3')
    }
  }

  // const handleVerifyOTP = async (otp) => {
  //   const payload = {
  //     mobile: mobile,
  //     otp: otp
  //   }
  //   try {
  //     const res = await verifyOTP(payload);
  //     if (res.data.status === 200) {
  //       handleSubmitData();
  //     }
  //   } catch (err) {
  //     toast.error(err.response.data.message)
  //     setOtpError(true);
  //   }
  // }

  useEffect(() => {
    const unloadCallback = (event) => {
      event.preventDefault();
      event.returnValue = "";
      return "";
    };
    const handleBackButton = () => {
      // console.log('browser baack')
      // const splitedPath = pathname.split('/');
      // if ((splitedPath.includes('new-integration') ||
      //     splitedPath[splitedPath.length - 1].split('?').includes('new-integration')) && steps < 4) {
      //     }
      setShowCloseConfirmationModal(true);
    }

    window.addEventListener("popstate", handleBackButton);
    window.addEventListener("beforeunload", unloadCallback);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
      window.removeEventListener("beforeunload", unloadCallback);
    };

  }, []);

  useEffect(() => {
    // Push a new history entry so back button doesn't exit immediately
    window.history.pushState(null, "", window.location.href);

    const handleBackButton = (event) => {
      event.preventDefault();
      // Do whatever you want here
      alert("Back button pressed!");

      // If you want to block going back:
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);


  return (
    <div className='bg-[#F8FAFB] !p-3 sm:!p-6 w-full sm:w-[1024px] mx-auto  overflow-auto relative'>
      {channerPartner === '1' && <div className='!pb-0'>
        <WelcomePage setChannelPartner={setChannelPartner} />
      </div>}
      {channerPartner === '2' && <CustomerInfo
        name={name}
        setName={setName}
        mobile={mobile}
        setMobile={setMobile}
        setChannelPartner={setChannelPartner}
        setIsWithCP={setIsWithCP}
        setIsCPVisit={setIsCPVisit}
        setShowSiteVisitOTPModal={setShowSiteVisitOTPModal}
        handleGetReVisitCustomerDetails={handleGetReVisitCustomerDetails}
      />}
      {
        channerPartner === '3' && <CustomerDetails
          setChannelPartner={setChannelPartner}
          isWithCP={isWithCP}
          setIsWithCP={setIsWithCP}
          detail={detail}
          preference={preference}
          setPrefrence={setPrefrence}
          investement={investement}
          setInvestment={setInvestment}
          purpose={purpose}
          setPurpose={setPurpose}
          altMobile={altMobile}
          setAltMobile={setAltMobile}
          mobile={mobile}
          setMobile={setMobile}
          setAboutProject={setAboutProject}
          aboutProject={aboutProject}
          handleChangeDetail={handleChangeDetail}
          possessionPreference={possessionPreference}
          setPossessionPreference={setPossessionPreference}
          others={others}
          setOthers={setOthers}
          referralMobile={referralMobile}
          setReferralMobile={setReferralMobile}
          referralName={referralName}
          setReferralName={setReferralName}
          society={society}
          setSociety={setSociety}
          flatNo={flatNo}
          setFlatNo={setFlatNo}
          city={city}
          setCity={setCity}
        />
      }
      {
        channerPartner === '4' && <BorkerDetailForm
          setChannelPartner={setChannelPartner}
          isWithCP={isWithCP}
          setBrokerName={setBrokerName}
          setBrokerMobile={setBrokerMobile}
          setCompanyId={setCompanyId}
          brokerName={brokerName}
          brokerMobile={brokerMobile}
          companyId={companyId}
        />
      }
      {
        channerPartner === '8' && <BrokerRegistration
          setChannelPartner={setChannelPartner}
          isWithCP={isWithCP}
          ownerName={ownerName}
          setOwnerName={setOwnerName}
          ownerMobile={ownerMobile}
          setOwnerMobile={setOwnerMobile}
          email={ownerMail}
          setEmail={setOwnerMail}
          name={newBrokerName}
          setName={setNewBrokerName}
          mobile={newBrokerMobile}
          setMobile={setNewBrokerMobile}
          companyName={companyName}
          setCompanyName={setCompanyName}
        />
      }
      {
        channerPartner === '9' && <CPRegistration
          setChannelPartner={setChannelPartner}
          isWithCP={isWithCP}
          ownerName={ownerName}
          setOwnerName={setOwnerName}
          ownerMobile={ownerMobile}
          setOwnerMobile={setOwnerMobile}
          email={ownerMail}
          setEmail={setOwnerMail}
          name={newBrokerName}
          setName={setNewBrokerName}
          mobile={newBrokerMobile}
          setMobile={setNewBrokerMobile}
          companyName={companyName}
          setCompanyName={setCompanyName}
          setCompanyId={setCompanyId}
          projectName={'Divine Reves'}
          setShowMobileField={setShowMobileField}
          showMobileField={showMobileField}
        />
      }
      {
        channerPartner === '5' && <CaptureImage
          setChannelPartner={setChannelPartner}
          setImage={setImage}
          image={image}
          handleSendOTP={handleSendOTP}
          isWithCP={isWithCP}
          name={detail.name || name}
          mobile={mobile}
          setImgUrl={setImgUrl}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          type={type}
          isCPVisit={isCPVisit}
        />
      }
      {
        channerPartner === '6' && <SiteVisitVerification
          otpError={otpError}
          setChannelPartner={setChannelPartner}
          otpVerifield={otpVerifield}
          setOTP={setOTP}
          handleVerifyOTP={handleSubmitData}
          mobile={isCPVisit ? newBrokerMobile : mobile}
          handleSendOTP={handleSendOTP}
          name={detail.name || name}
          countDown={countDown}
          disableResend={disableResend}
          email={detail.email}
          isCPVisit={isCPVisit}
          handleSubmitCPVisit={handleSubmitCPVisit}
          isSubmitting={isSubmitting}
          setShowCustomerRevisitModal={setShowCustomerRevisitModal}
          isRevisit={isRevisit}
        />
      }
      {
        channerPartner === '7' && <BrokerVerification setChannelPartner={setChannelPartner} />
      }
      {
        channerPartner === '10' && <AppQRCode setChannelPartner={setChannelPartner} />
      }
      {showCloseConfirmationModal && <AreYouSureModal
        show={showCloseConfirmationModal}
        closeModal={() => setShowCloseConfirmationModal(false)}
        subText={'Do you want to cancel ? Any unsaved changes you made may be lost.'}
        confirmClose={() => window.location.reload()}
      />}
      {
        showCustomerRevisitModal && <CustomerRevisitModal
          show={showCustomerRevisitModal}
          closeModal={() => { setShowCustomerRevisitModal(false) }}
          customerData={customerData}
          note={note}
          setNote={setNote}
          handleSendOTP={handleSendOTP}
          setChannelPartner={setChannelPartner}
          isWithCP={isWithCP}
        />
      }
      {
        showSiteVisitOTPModal && <SiteVisitOTPModal show={showSiteVisitOTPModal} closeModal={() => setShowSiteVisitOTPModal(false)} />
      }
      {
        showVerifyIdentityModal && <VerifyIdentityModal show={showVerifyIdentityModal} closeModal={() => setShowVerifyIdentityModal(false)} />
      }
    </div>
  )
}

export default DivineReves;